var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8755 15C20.7152 15 19.6024 15.4609 18.7819 16.2814C17.9614 17.1019 17.5005 18.2147 17.5005 19.375C17.5005 20.5353 17.9614 21.6481 18.7819 22.4686C19.6024 23.2891 20.7152 23.75 21.8755 23.75H30.0005V30H0.000488281V8.75H30.0005V15H21.8755ZM23.1255 21.25H21.8755C21.3782 21.25 20.9013 21.0525 20.5497 20.7008C20.198 20.3492 20.0005 19.8723 20.0005 19.375C20.0005 18.8777 20.198 18.4008 20.5497 18.0492C20.9013 17.6975 21.3782 17.5 21.8755 17.5H23.1255C23.6228 17.5 24.0997 17.6975 24.4513 18.0492C24.8029 18.4008 25.0005 18.8777 25.0005 19.375C25.0005 19.8723 24.8029 20.3492 24.4513 20.7008C24.0997 21.0525 23.6228 21.25 23.1255 21.25ZM20.0005 0L25.0005 6.25H10.0005L20.0005 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.abae332655d1275332d860872349612f.svg";
export { ForwardRef as ReactComponent };